// src/components/DotsSpinner.tsx
import React from 'react';

interface DotsSpinnerProps {
  size?: number;              // larghezza in px
  strokeColor?: string;       // colore del cerchio
  duration?: string;          // durata dell’animazione
}

const DotsSpinner: React.FC<DotsSpinnerProps> = ({
  size = 60,
  strokeColor = 'hsl(228, 97%, 42%)',
  duration = '2.2s',
}) => (
  <svg
    width={size}
    height={(size * 60) / 57}
    viewBox="0 0 57 60"
    xmlns="http://www.w3.org/2000/svg"
    stroke={strokeColor}
    role="img"
    aria-label="Loading…"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)" strokeWidth="3">
        <circle cx="5" cy="50" r="5">
          <animate
            attributeName="cy"
            begin="0s"
            dur={duration}
            values="50;5;50;50"
            calcMode="linear"
            repeatCount="indefinite"
          />
          <animate
            attributeName="cx"
            begin="0s"
            dur={duration}
            values="5;27;49;5"
            calcMode="linear"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="27" cy="5" r="5">
          <animate
            attributeName="cy"
            begin="0s"
            dur={duration}
            values="5;50;50;5"
            calcMode="linear"
            repeatCount="indefinite"
          />
          <animate
            attributeName="cx"
            begin="0s"
            dur={duration}
            values="27;49;5;27"
            calcMode="linear"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="49" cy="50" r="5">
          <animate
            attributeName="cy"
            begin="0s"
            dur={duration}
            values="50;50;5;50"
            calcMode="linear"
            repeatCount="indefinite"
          />
          <animate
            attributeName="cx"
            begin="0s"
            dur={duration}
            values="49;5;27;49"
            calcMode="linear"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </g>
  </svg>
);

export default DotsSpinner;
